module.exports = __webpack_public_path__ + "static/ue-fund1-31d84b1b2df8e17b766edb059890fcfd.png";